import React, {ReactNode} from 'react';
import classNames from 'classnames';
import FocusModeExitControl from './FocusModeExitControl.tsx';

interface FocusModeShellProps {
    isFocusMode?: boolean;
    onExit?: () => void;
    // Which kind of tab is inside; _focus-mode.scss fits each to the window.
    variant: 'scene' | 'website' | 'content';
    exitLabel?: string;
    children: ReactNode;
}

/*
 * Full screen for the tabs that don't lay it out themselves (scene, website,
 * content). Whiteboard, vibe code and blocks tabs put the same classes on
 * their own surfaces, because each hides different editor chrome.
 */
const FocusModeShell: React.FC<FocusModeShellProps> = ({
    isFocusMode = false,
    onExit = () => undefined,
    variant,
    exitLabel,
    children
}) => (
    <div
        className={classNames(
            'focus-mode-surface',
            'focus-mode-shell',
            `focus-mode-shell--${variant}`,
            {'focus-mode-surface--active': isFocusMode}
        )}
    >
        {isFocusMode && (
            <FocusModeExitControl onExit={onExit} label={exitLabel} />
        )}
        {children}
    </div>
);

export default FocusModeShell;
